'use client';

import AssetsPage from '@/app/assets/components/AssetsPage';
import { AssetsFallbackSkeleton } from '@/app/assets/components/table/Skeletons';
import { UserQueryErrorBanner } from '@/shared/queryErrorBanners/UserQueryErrorBanner';
import { useUserQuery } from '@/shared/hooks/useUserQuery';

type AssetsRootPageProps = {
  searchParams: {
    query?: string;
    page?: string;
    onlyOutputs?: string;
  };
};

export function AssetsPageRoot({ searchParams }: AssetsRootPageProps) {
  const { data: userData, isLoading, isError } = useUserQuery();

  if (isError) {
    return <UserQueryErrorBanner />;
  }

  if (isLoading || !userData) {
    return <AssetsFallbackSkeleton />;
  }

  const showOnlyOutputs = searchParams.onlyOutputs === 'true';
  const hasRapidPbrSupport = userData.plan?.details?.rapidpbr_support;
  const hasCad = userData.plan?.details?.cad_support;
  const hasAdvancedCad = userData.plan?.details?.advanced_cad_support;

  return (
    <AssetsPage
      userMaxAllowedFileSize={userData.plan.max_upload_filesize}
      hasCadSupport={hasCad}
      hasAdvancedCadSupport={hasAdvancedCad}
      hasRapidPBRSupport={hasRapidPbrSupport}
      storageLeft={userData.plan.storage_left}
      storageLimit={userData.plan.details.storage_limit}
      showOnlyOutputs={showOnlyOutputs}
    />
  );
}
